import React from 'react';
import * as _ from "lodash";
import {Link} from "react-router-dom";

const splitRegistrationCode = (code, targetLength, start) => {
    const charArray = _.split(code, '');
    const firstPart = _.take(charArray, start).join('');
    const target = _.slice(charArray, start, start + targetLength).join('');
    const secondPart = _.takeRight(charArray, charArray.length - (start + targetLength)).join('');
    return {firstPart, target, secondPart};
};

const EBadgeRegistrationCode = ({content, linkToPhotoMgmt,isMatchBlockList}) => {
    
    const splitedCode = splitRegistrationCode(content, 2, 6);
    const highlightedPart = (parseInt(splitedCode.target) < new Date().getFullYear() % 100) ? (
        <span style={{color: 'red'}}>{splitedCode.target}</span>
    ) : (splitedCode.target);
    if (linkToPhotoMgmt) {
        if (isMatchBlockList === "Y"){
            return (
                <Link to={`/photo/query?page=1&registrationCode=${content}`}><span style={{color: 'red'}}>{splitedCode.firstPart}{highlightedPart}{splitedCode.secondPart}</span></Link>
            );
        }else{
            return (
                <Link to={`/photo/query?page=1&registrationCode=${content}`}>{splitedCode.firstPart}{highlightedPart}{splitedCode.secondPart}</Link>
            );
        }
    } else {
        if (isMatchBlockList === "Y"){
            return (
                <span style={{color: 'red'}}>{splitedCode.firstPart}{highlightedPart}{splitedCode.secondPart}</span>
            );
        }else{
            return (
                <span>{splitedCode.firstPart}{highlightedPart}{splitedCode.secondPart}</span>
            );
        }
    }

};

export default EBadgeRegistrationCode;


// WEBPACK FOOTER //
// ./src/components/ebadge/EBadgeRegistrationCode.js